module.exports = __webpack_public_path__ + "media/images/illustrations/location_truck_tracking-83ce40bc9a8f433f6dc3867574abd6d3.svg";